module.exports = __webpack_public_path__ + "img/HPS011CP.dca379af.png";